var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProgressLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  rx: 22,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 29C23.8565 29 25.637 28.2625 26.9497 26.9497C28.2625 25.637 29 23.8565 29 22",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 15C20.1435 15 18.363 15.7375 17.0503 17.0503C15.7375 18.363 15 20.1435 15 22",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})));
export default SvgProgressLarge;